import React from 'react';

const Team = () => {
  return <div>Team Page</div>;
};

export default Team;